import { GetReportResponse } from '@/hooks'
import { ReportDetailsActionsDropdown } from './ReportDetailsActionsDropdown'
import { useDeleteReport } from '@/features/Reporting/hooks/useDeleteReport/useDeleteReport'

type ReportDetailsActionsProps = {
    reportData: GetReportResponse
}

export const ReportDetailsActions: React.FC<ReportDetailsActionsProps> = ({
    reportData,
}) => {
    const { openDeleteReportModal } = useDeleteReport({
        reportId: reportData.customReportId,
        reportName: reportData.name,
        type: reportData.type,
    })

    return (
        <div className="pr-6">
            <ReportDetailsActionsDropdown
                handleClickDeleteReport={openDeleteReportModal}
                reportData={reportData}
            />
        </div>
    )
}
